<div class="successful-redeem-dialog ups-dialog {{ dialogClass }}">
    <h2 mat-dialog-title *ngIf="title" [ngClass]="titleClass">{{ title }}</h2>
    <div class="key-key"></div>
    <mat-dialog-content>
        <div class="dialog-content {{ messageClass }}" [innerHtml]="message"></div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button mat-raised-button [mat-dialog-close]="true"> {{cancel}} <span class="material-symbols-outlined">chevron_right</span> </button>
    </mat-dialog-actions>

    <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

